(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    function initKukun(scope=document){
 scope.querySelectorAll('[data-product-section]').forEach(section=>{
  if(section.dataset.initialized)return;section.dataset.initialized='true';
  const gallery=section.querySelector('[data-main-gallery]');
  const showMedia=id=>{const button=section.querySelector('[data-media-id="'+CSS.escape(String(id))+'"]');if(!button)return;const template=button.nextElementSibling;if(!(template instanceof HTMLTemplateElement))return;gallery.replaceChildren(template.content.cloneNode(true));section.querySelectorAll('[data-media-id]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));};
  section.querySelectorAll('[data-media-id]').forEach(button=>button.addEventListener('click',()=>showMedia(button.dataset.mediaId)));
  const select=section.querySelector('[data-variant-select]');const addButton=section.querySelector('[data-add-button]');
  select?.addEventListener('change',()=>{const option=select.selectedOptions[0];const price=section.querySelector('[data-price]');price.textContent=option.dataset.price; if(option.dataset.compare){const compare=document.createElement('s');compare.textContent=option.dataset.compare;price.append(' ',compare);}addButton.disabled=option.dataset.available!=='true';addButton.textContent=addButton.disabled?addButton.dataset.soldLabel:addButton.dataset.availableLabel;const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);if(option.dataset.media)showMedia(option.dataset.media);});
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initKukun());else initKukun();
document.addEventListener('shopify:section:load',event=>initKukun(event.target));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.native-menu[open],.nav-group[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus()})});

function initMotion(scope=document){
 scope.querySelectorAll('[data-motion-section]').forEach(section=>{
  if(section.dataset.motionReady)return;section.dataset.motionReady='true';
  const videos=Array.from(section.querySelectorAll('video'));
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const connection=navigator.connection;
  const visible=new Set();const automaticPauses=new WeakSet();
  const controller=new AbortController();const options={signal:controller.signal};
  const pause=video=>{if(!video.paused){automaticPauses.add(video);video.pause()}};
  const update=video=>{
   if(document.hidden||!visible.has(video)){pause(video);return}
   if(motion.matches||connection?.saveData||video.dataset.userPaused)return;
   video.play().catch(()=>{});
  };
  const posters=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(!entry.isIntersecting)return;
   const video=entry.target;if(video.dataset.poster){video.poster=video.dataset.poster;delete video.dataset.poster}
   posters.unobserve(video);
  }),{rootMargin:'200px 0px'});
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(entry.isIntersecting&&entry.intersectionRatio>=.5)visible.add(entry.target);else visible.delete(entry.target);
   update(entry.target);
  }),{threshold:.5});
  videos.forEach(video=>{
   video.addEventListener('pause',()=>{if(automaticPauses.has(video))automaticPauses.delete(video);else video.dataset.userPaused='true'},options);
   video.addEventListener('play',()=>{delete video.dataset.userPaused},options);
   posters.observe(video);observer.observe(video);
  });
  document.addEventListener('visibilitychange',()=>videos.forEach(update),options);
  motion.addEventListener('change',()=>videos.forEach(video=>motion.matches?pause(video):update(video)),options);
  connection?.addEventListener('change',()=>videos.forEach(video=>connection.saveData?pause(video):update(video)),options);
  const toggle=section.querySelector('[data-motion-toggle]');toggle?.addEventListener('click',()=>{
   const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));
   toggle.textContent=expanded?toggle.dataset.expand+' +':toggle.dataset.collapse+' −';
   section.querySelectorAll('[data-extra-feature]').forEach(card=>{card.hidden=expanded;if(expanded)pause(card.querySelector('video'))});
  },options);
  section.motionCleanup=()=>{controller.abort();observer.disconnect();posters.disconnect();videos.forEach(pause)};
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initMotion());else initMotion();
document.addEventListener('shopify:section:load',event=>initMotion(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-motion-section]').forEach(section=>section.motionCleanup?.()));


function initKukunReviews(scope=document){
 scope.querySelectorAll('[data-review-link]').forEach(link=>{
  if(link.dataset.reviewReady)return;link.dataset.reviewReady='true';
  const label=link.getAttribute('aria-label');
  const sync=()=>{const rating=link.querySelector('.oke-a11yText')?.textContent?.trim();if(rating)link.setAttribute('aria-label',rating+'. '+label)};
  const observer=new MutationObserver(sync);observer.observe(link,{childList:true,subtree:true,characterData:true});sync();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initKukunReviews());else initKukunReviews();
document.addEventListener('shopify:section:load',event=>{initKukunReviews(event.target);event.target.querySelectorAll('[data-oke-star-rating],[data-oke-widget]').forEach(element=>window.okeWidgetApi?.initWidget(element))});
document.addEventListener('click',event=>{const link=event.target.closest('[data-review-link][href="#product-reviews"]');if(!link)return;const reviews=document.getElementById('product-reviews');if(!reviews)return;event.preventDefault();reviews.focus({preventScroll:true});reviews.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});history.replaceState(null,'','#product-reviews')});
  } catch(e) { console.error(e); }
})();

})();
